import {
  ComponentRef,
  Directive,
  ElementRef,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { ShowMoreButtonComponent } from '../components/show-more-button/show-more-button.component';

@Directive({
  selector: '[appShowMore]',
  standalone: true,
})
export class ShowMoreDirective implements OnInit {
  constructor(
    private container: ViewContainerRef,
    private element: ElementRef
  ) {}

  ngOnInit(): void {
    this.element.nativeElement.style.height = '105px';

    const button: ComponentRef<ShowMoreButtonComponent> =
      this.container.createComponent(ShowMoreButtonComponent);

    button.instance.parent = this.element;
  }
}
